module.exports = __webpack_public_path__ + "img/declare2.2be587a0.jpg";